import React from 'react';
import styled from 'styled-components';

import RatingsReview from '@rover/components/src/RatingsReview/RatingsReview';
import Rebook from '@rover/icons/svg/rebook.svg';
import Trophy from '@rover/icons/svg/trophy.svg';
import { Flex, Text } from '@rover/kibble/core';

import TruncatedText from '../../../components/TruncatedText';

const ICON_SIZE = 16;
const ROW_GAP_PX = 8;
const COLUMN_GAP_PX = 16;
const PILL_FIRST_COLUMN_WIDTH_PX = 170;
const PILL_REFLOW_WIDTH_PX = 428;

const GridContainer = styled.div<{ singleColumn?: boolean }>`
  display: grid;
  gap: ${ROW_GAP_PX}px ${COLUMN_GAP_PX}px;
  grid-template-columns: ${(props) =>
    props.singleColumn ? '' : `${PILL_FIRST_COLUMN_WIDTH_PX}px 1fr`};
  grid-template-areas: 'ratings method' 'yoe certs';
  width: 100%;

  /* Technically we care about the card width, but on narrow layouts, the card width is the viewport width */
  @media (max-width: ${PILL_REFLOW_WIDTH_PX}px) {
    display: flex;
    flex-direction: column;
    max-width: unset;
  }
`;

interface TrainerPillsProps {
  ratingsAverage?: string | null;
  reviewsCount: number;
  yearsOfExperience: string;
  repeatClientCount: number;
  isAllServicesClientCountActive: boolean;
}
export default function TrainerPills({
  ratingsAverage,
  reviewsCount,
  yearsOfExperience,
  repeatClientCount,
  isAllServicesClientCountActive,
}: TrainerPillsProps): React.ReactElement {
  const shouldShowRatingsReviews = reviewsCount > 0;

  const shouldShowRepeatClientCount = repeatClientCount > 0;
  const trainingLabel = isAllServicesClientCountActive ? '' : 'training ';
  const repeatClientCountText = `${repeatClientCount} repeat ${trainingLabel}client${
    repeatClientCount === 1 ? '' : 's'
  }`;

  const singleColumn = !shouldShowRatingsReviews;

  return (
    <GridContainer singleColumn={singleColumn}>
      {shouldShowRatingsReviews && (
        <Flex sx={{ gridArea: 'ratings' }}>
          <RatingsReview
            ratingsAverage={ratingsAverage ?? ''}
            reviewsCount={reviewsCount}
            fontWeight="regular"
          />
        </Flex>
      )}
      {shouldShowRepeatClientCount && (
        <Flex gap="1x" /* No grid-area so that it can occupy first column when no reviews */>
          <Rebook width={ICON_SIZE} height={ICON_SIZE} />
          <TruncatedText size="100">{repeatClientCountText}</TruncatedText>
        </Flex>
      )}

      <Flex gap="1x" sx={{ gridArea: 'yoe' }}>
        <Trophy width={ICON_SIZE} height={ICON_SIZE} />
        <Text size="100">{yearsOfExperience}</Text>
      </Flex>
    </GridContainer>
  );
}
